<script>
import copyTextSVG from '../../../../assets/images/copy_text.svg';

export default {
  props: {
    show: Boolean,
    hash: String
  },
  data() {
    return {
      copyTextSVG: copyTextSVG
    }
  },
  methods: {
  },
}
</script>

<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask user-modal__backdrop">
      <div class="modal-wrapper">
        <div class="modal-container-wallet user-modal__panel user-modal__body">
          <div class="modal-close">
            <slot name="close-button">
              <button
                class="modal-default-button user-modal__close"
                @click="$emit('close')"
              ><span class="material-icons-sharp" aria-hidden="true">cancel</span></button>
            </slot>
          </div>
          <div class="modal-header">
            <h3 class="user-modal__title">Hash:</h3>

          </div>

          <div class="modal-body modal-header user-modal__body">
            <p class="flex-auto">{{ hash }}</p>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.modal-wrapper { display: block; width: 100%; }
.modal-container-wallet { position: relative; display: flex; flex-direction: column; margin: auto; }
.modal-close { display: contents; }
.modal-body p + p { margin-top: var(--user-modal-gap); }
.modal-body { overflow-wrap: anywhere; }
.modal-enter-from, .modal-leave-to { opacity: 0; }
.modal-enter-from .modal-container-wallet, .modal-leave-to .modal-container-wallet { transform: scale(1.1); }
</style>
